"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSCWebSession = exports.tryCreateOrUpdateSession = exports.tryGetActiveSession = exports.SC_WEB_SESSION_ID = void 0;
// TODO: add tests!
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const react_1 = require("react");
const uuid_1 = require("uuid");
const sc_cookies_1 = require("./sc-cookies");
dayjs_1.default.extend(utc_1.default);
exports.SC_WEB_SESSION_ID = "_sc-sid";
function canHaveWebSession() {
    if ((0, sc_cookies_1.hasOptedOutFromEssentialSession)(document.cookie)) {
        // Session ID is an essential session identifier. Learn about EssentialSession Cookies here - https://docs.google.com/document/d/1EjCg_7-uaVstzxDX54YhWs3WVdWsxtGow6zSnXXdGY4/edit and https://snapchat.quip.com/Lv7cAd7q5kLF
        const scopedDomain = (0, sc_cookies_1.getScopedCookieDomain)(document.location.host);
        if (js_cookie_1.default.get(exports.SC_WEB_SESSION_ID)) {
            js_cookie_1.default.remove(exports.SC_WEB_SESSION_ID, { domain: scopedDomain });
        }
        return false;
    }
    return true;
}
/**
 * Tries to get the active session for the viewer. Returns
 * undefined if the viewer has opted out of essential session cookies
 * or if the session has expired.
 */
const tryGetActiveSession = () => {
    if (!canHaveWebSession()) {
        return undefined;
    }
    return js_cookie_1.default.get(exports.SC_WEB_SESSION_ID);
};
exports.tryGetActiveSession = tryGetActiveSession;
/**
 * Creates a new session if none is found, or updates the existing
 * one if it hasn't expired. Duplicating a tab or reloading the page
 * will not create a new session - opening a new page will.
 *
 * A session ends when a user is inactive for 30 minutes or when
 * reaching end of day (UTC+00).
 */
const tryCreateOrUpdateSession = () => {
    if (!canHaveWebSession()) {
        return undefined;
    }
    // session_id is an essential identifier. we don't need user consent to store it
    const existingSession = (0, exports.tryGetActiveSession)();
    const sessionId = existingSession || (0, uuid_1.v4)();
    const now = dayjs_1.default.utc();
    const endOfDay = (0, dayjs_1.default)(now).endOf("day");
    const in30Minutes = (0, dayjs_1.default)(now).add(30, "minutes");
    const eodDiff = endOfDay.diff(now);
    const thirtyMinDiff = in30Minutes.diff(now);
    // we expire the session EOD even if we haven't reached 30 minutes of inactivity
    const expires = eodDiff < thirtyMinDiff ? endOfDay.toDate() : in30Minutes.toDate();
    const scopedDomain = (0, sc_cookies_1.getScopedCookieDomain)(document.location.host);
    js_cookie_1.default.set(exports.SC_WEB_SESSION_ID, sessionId, { expires, domain: scopedDomain, secure: true });
    return sessionId;
};
exports.tryCreateOrUpdateSession = tryCreateOrUpdateSession;
function handleVisibilityChange() {
    if (document.visibilityState === "visible") {
        (0, exports.tryCreateOrUpdateSession)();
    }
}
/**
 * Web sessions are tracked through a cookie, we'll
 * only track it if the viewer has agreed to using snapchat cookies.
 *
 * A session ends when a viewer is inactive for 30 minutes or when
 * reaching end of day (UTC+00). Duplicating a tab or reloading the page
 * will not create a new session - opening a new page will.
 */
function useSCWebSession() {
    (0, react_1.useEffect)(() => {
        // as this hook will run when a page first loads, make sure that we try to create an initial
        // session, then register the visibility change listener so we update it on subsequent changes
        (0, exports.tryCreateOrUpdateSession)();
        // add a listener so we can update the session every time we go from hidden -> visible
        document.addEventListener("visibilitychange", handleVisibilityChange, false);
        return () => {
            window.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);
}
exports.useSCWebSession = useSCWebSession;
//# sourceMappingURL=sc-sessions.js.map